import{erpplatfileserver} from '@/utils/baseUrl';
import{flowserver} from '@/utils/baseUrl';
import {post} from '@/utils/request';

//报表
export async function loadDataFromSvr(params) {
    return post(flowserver+'/flow/getFlowTemplate', params, true);
}

//save flow
export async function saveFlowTemplate(params) {
    return post(flowserver+'/flow/saveFlowTemplate', params, true);
}


//报表
export async function loadFlowList(params) {
    return post(flowserver+'/flow/getFlowList', params, true);
}

//子流程
export async function loadSubFlowList(params) {
    return post(flowserver+'/flow/getSubFlowList', params, true);
}
//测试创建审批
export async function getFlowNodeState(params) {
    return post(flowserver+'/flow/subFlow', params, true);
}
//测试审批step
export async function getFlowStepState(params) {
    return post(flowserver+'/flow/testSubStep', params, true);
}

//获取审批分类
export async function getFlowType(params) {
    return post(flowserver+'/flow/getFlowType', params, true);
}
//获取审批类型
export async function getFlowSpType(params) {
    return post(flowserver+'/flow/getFlowSpType', params, true);
}
//获取审批岗位职级
export async function getGwzj(params) {
    return post(flowserver+'/flow/getGwzj', params, true);
}

//获取审批回调对象
export async function getCallBackList(params) {
    return post(flowserver+'/flow/getCallbackList', params, true);
}
export default {
    loadDataFromSvr,
    saveFlowTemplate,
    loadFlowList,
    getFlowNodeState,
    getFlowStepState,
    loadSubFlowList,
    getFlowType,
    getFlowSpType,
    getGwzj,
    getCallBackList,
}





